import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

const DraggableSection = ({ id, children, isEditMode }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
  };

  if (!isEditMode) {
    return <div>{children}</div>;
  }

  return (
    <div ref={setNodeRef} style={style} className="group">
      {/* Drag handle */}
      <div
        {...attributes}
        {...listeners}
        className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 p-2 cursor-grab active:cursor-grabbing 
                   bg-primary/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity
                   hover:bg-primary/20 touch-none"
        title="Glisser pour réorganiser"
      >
        <GripVertical className="w-4 h-4 text-primary" />
      </div>
      
      {/* Content with highlight border in edit mode */}
      <div className={`${isDragging ? 'ring-2 ring-primary ring-offset-2 rounded-xl' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default DraggableSection;
